import {
  MASTER_COMPANY_LIST,
  COMPANY_REQUEST_LIST,
  COMPANY_REQUEST_DETAIL,
  MASTER_COMPANY_LIST_ERROR,
  CLEAR_MASTER_COMPANY_ERROR,
} from "./constant";

export const initialState = {
  masterCompanyList: [],
  masterCompanyListError: null,
  companyPagination: {
    totalRecord: 0,
    currentRecord: 0,
    currentPage: 1,
    nextPage: 0,
    totalPage: 1,
  },
  companyRequestList: [],
  companyRequestCache: {},
  companyRequestListPagination: {
    totalRecord: 0,
    currentRecord: 0,
    currentPage: 1,
    nextPage: 0,
    totalPage: 1,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case MASTER_COMPANY_LIST:
      return {
        ...state,

        masterCompanyList: action.payload.data || [],

        companyPagination: action.payload.pagination || {},

        masterCompanyListError: null,
      };

    case MASTER_COMPANY_LIST_ERROR:
      return {
        ...state,

        masterCompanyListError: action.payload || "Something went wrong",
      };

    case CLEAR_MASTER_COMPANY_ERROR:
      return {
        ...state,

        masterCompanyListError: null,
      };

    case COMPANY_REQUEST_LIST:
      return {
        ...state,
        companyRequestList: action.payload.data || [],

        companyRequestListPagination: action.payload.pagination || {},
      };

    case "CACHE_COMPANY_REQUEST_LIST": {
      return {
        ...state,
        companyRequestCache: {
          ...state.companyRequestCache,
          [action.payload.key]: {
            response: action.payload.response,
            timestamp: action.payload.timestamp,
          },
        },
      };
    }

    case "CLEAR_COMPANY_REQUEST_CACHE": {
      return {
        ...state,
        companyRequestCache: {},
      };
    }

    default:
      return state;
  }
};
